/**
 * Permission computeds for Program Defaults template management.
 * Requires host component to map `permissions` from Vuex state.
 * Requires host component to expose `data.procoreTemplate` for TemplateExists.
 * Used by: src/views/Procore.vue
 */
export default {
  computed: {
    CanEditDefaults() {
      return this.permissions.includes("programs:write:defaults");
    },
    CanViewDefaults() {
      return this.permissions.includes("programs:read:defaults");
    },
    TemplateExists() {
      return !!(this.data.procoreTemplate && Object.keys(this.data.procoreTemplate).length);
    },
    Step2Locked() {
      return !this.CanEditDefaults && this.TemplateExists;
    },
  },
};
